import { Container, Spinner } from '@chakra-ui/react'
import { Link } from 'react-router-dom'
import React from 'react'
import useQuery from '../../../hooks/useQuery'
import { endpoints, postFunc } from '../../../api'
import { showToast } from '../../../utils/toast'
import VerifySuccessful from '../../../assets/icons/verify-succesful.svg'
import VerifyFailed from '../../../assets/icons/verify-failed.svg'

const VerifyEmail = () => {
  const [verified, setVerified] = React.useState(false)

  const [loading, setLoading] = React.useState(true)

  const query = useQuery()

  React.useEffect(() => {
    setLoading(true)
    postFunc(`${endpoints.verifyEmail}?token=${query.get('token')}`)
      .then((data) => {
        setVerified(true)
      })
      .catch((err) => {
        setVerified(false)
        showToast({
          id: 'email-verifcation-error',
          title: 'Email verification failed',
          description: err.message,
          status: 'error',
        })
      })
      .finally(() => {
        setLoading(false)
      })
  }, [query])

  return (
    <Container
      display="flex"
      alignItems="center"
      flexDir="column"
      mt="36"
      width="fit-content"
      textAlign="center"
      gap="10px"
    >
      {loading ? (
        <>
          <Spinner
            thickness="4px"
            speed="0.65s"
            emptyColor="gray.200"
            color="blue.500"
            size="xl"
          />
          <p>Please wait while we verify your email.</p>
        </>
      ) : (
        <>
          {verified ? (
            <div className="space-y-10 flex flex-col items-center leading-7">
              <img
                src={VerifySuccessful}
                alt="Successful Icon"
                width={51}
                height={51}
                className="bg-[#069E2D] border rounded-full p-2 "
              />
              <div className="font-medium text-center">
                <p>Email is successfully verified.</p>
                <p>
                  Proceed to{' '}
                  <Link to="/auth/login" title="Login" style={{ color: '#468FAF' }}>
                    {' '}
                    login
                  </Link>{' '}
                  or visit the{' '}
                  <Link to="/" title="Login" style={{ color: '#468FAF' }}>
                    homepage.
                  </Link>
                </p>
              </div>
            </div>
          ) : (
            <div className="space-y-[40px] flex flex-col items-center leading-7">
              <img
                src={VerifyFailed}
                alt="close Icon"
                width={50}
                height={50}
                className="bg-[#BD1F21] border rounded-full "
              />
              <div className="font-medium space-y-10 text-lg">
                <div>
                  <p>Email could not be verified</p>
                  <p>This could be due to an invalid or expired link.</p>
                </div>
                <div>
                  <p>Don't worry, We will send you another if it is expired.</p>
                  <p>Check your mail.</p>
                </div>
                <p>
                  Visit the{' '}
                  <Link to="/" title="Login" style={{ color: '#468FAF' }}>
                    homepage.
                  </Link>
                </p>
              </div>
            </div>
          )}
        </>
      )}
    </Container>
  )
}

export default VerifyEmail
